import Axios from 'axios';
import { httpAPI } from "@/api/httpAPI";
import i18n from '@/i18n'
import sys from '@/services/system';

const comments = {
    namespaced: true,    
    state: {
        isActive: false,
        isPending: null,
        cancellationTokenSorce: null,
        dataSource: [],

        currentDocumentId: null,
        loadingAttachments: {},
    },
    mutations: {
        SET_IS_ACTIVE(state, payload) {
            state.isActive = payload;
        },
        SET_IS_PENDING(state, payload) {
            state.isPending = payload;
        },
        SET_CANCELLATION_TOKEN_SOURCE(state, payload) {
            state.cancellationTokenSorce = payload;
        },
        SET_DATASOURCE(state, payload) {            
            state.dataSource = payload;
        },
        SET_CURRENT_DOCUMENT_ID(state, payload) {
            state.currentDocumentId = payload;
        },
        ADD_LOADIGN_COMMENT_ATTACHMENT(state, payload) 
        {            
            if (!state.loadingAttachments[payload.id])
                state.loadingAttachments[payload.id] = [];

            let data = state.loadingAttachments[payload.id];
            
            if (!data.find(i => i.Id == payload.comment.Id))
                data.push(payload.comment);
        },
        DEL_LOADIGN_COMMENT_ATTACHMENT(state, payload) 
        {            
            if (!state.loadingAttachments[payload.id])
                return;

            var data = state.loadingAttachments[payload.id]
            var item = data.find(i => i.Id == payload.comment.Id);

            if (item)
            {
                data.splice(data.indexOf(item), 1);

                if (data.length == 0)
                    delete state.loadingAttachments[payload.id];
            }
        },
        UPDATE_lOADING_COMMENT_ATTACHMENT(state, payload)
        {
            this._vm.$_.set(state.loadingAttachments, payload.property, payload.value)
        },
        PUSH_DATASOURCE(state, payload) {
            if (!state.dataSource.find(i => i.id == payload.comment.Id))
                state.dataSource.push(payload.comment);
        },
        UPDATE_DATASOURCE(state, payload) {                        
            state.dataSource[payload.index].Attachment = payload.value.Attachment;
            state.dataSource[payload.index].Id = payload.value.Id;
            delete state.dataSource[payload.index].IsNew;
        }
    },
    actions: {  
        setPreviewSrc({ commit }, previewSrc) {
            commit({ type: 'SET_PREVIEW_SRC', previewSrc });
        },
        setDataSource({commit}, dataSource) {
            commit({ type: 'SET_DATASOURCE', dataSource });
        },
        async updateDataSource({ state, commit, rootGetters }) {
            commit('SET_DATASOURCE', [] );

            if (state.cancellationTokenSorce)
                state.cancellationTokenSorce.cancel('New request started');

            commit('SET_CANCELLATION_TOKEN_SOURCE', Axios.CancelToken.source());
            let docid = rootGetters['global/actionsource/getDataSourceDocumentId'];
            let url = `api/tabs/comments/${docid}`;
            if (rootGetters['global/actionsource/getDataSourceType'] == "PlannedMeeting"){
                docid = rootGetters['global/actionsource/getDataSourceIdentifier'];    
                url = `api/plannedevent/comments/${docid}`;
            }
            commit('SET_CURRENT_DOCUMENT_ID', docid);

            let response = await httpAPI({
                url,
                method: 'GET',
                cancelToken: state.cancellationTokenSorce.token,
                headers: { 'isCommon': rootGetters['global/actionsource/isDataSourceCommon'] },
            });            

            if (response) {
                var loadingAttachments = state.loadingAttachments[state.currentDocumentId] ?? [];
                var data = response.data.Payload;

                data.forEach(i => { i.IsActive = false; });

                if (loadingAttachments.length > 0)
                    data = data.concat(loadingAttachments);

                commit('SET_DATASOURCE', data);
            }
            else
                commit('SET_DATASOURCE', [] );
        }, 
        setIsActive({commit}, isActive) {
            commit('SET_IS_ACTIVE', isActive);
        },
        setCurrentDocumentId({ commit }, id) {
            commit({ type: 'SET_CURRENT_DOCUMENT_ID', id });
        },
        async onFileCommentPicked({ state, commit, getters, dispatch, rootGetters }, { e }) {

            await Promise.all(Array.from(e.target.files).map( async (f) => {
                    
                let currentTimeStamp = await dispatch('documents/references/getTimestamp', null, { root: true });
                let attachment = sys.prepareAttachment(f, state.dataSource, this._vm.$notify);
                
                let comment = {
                    Id: sys.generateUUID(),
                    AuthorId: rootGetters['global/auth/getUserInfo'].WorkplaceId,                    
                    AuthorName: rootGetters['global/auth/getUserInfo'].UserName,
                    EnterpriseName: rootGetters['global/auth/getUserInfo'].EnterpriseName,
                    CommentDate: sys.dateFormat(currentTimeStamp, 'DD.MM.YYYY HH:mm:ss'),
                    Attachment: attachment,
                    IsNew: true
                };

                let currentDocumentId = rootGetters['global/actionsource/getDataSourceDocumentId']
                let url = `/api/actions/savecommentattachment?id=${currentDocumentId}&fileName=${attachment.Name}&fileSize=${attachment.Length}`;
                let isCommon = rootGetters['global/actionsource/isDataSourceCommon'];

                if (rootGetters['global/actionsource/getDataSourceType'] == "PlannedMeeting") {
                    currentDocumentId = rootGetters['global/actionsource/getDataSourceIdentifier'];
                    url = `/api/plannedevent/savecommentattachment?id=${currentDocumentId}&fileName=${attachment.Name}&fileSize=${attachment.Length}`;
                    isCommon = true;
                }
                
                await commit('global/comments/ADD_LOADIGN_COMMENT_ATTACHMENT', { id: currentDocumentId, comment: comment }, { root: true })
                await commit('global/comments/PUSH_DATASOURCE', { comment }, { root : true });                

                if (attachment.Message)
                {
                    await commit('global/comments/DEL_LOADIGN_COMMENT_ATTACHMENT', { id: currentDocumentId, comment: comment }, { root: true });
                    return;
                }
                
                let formData = new FormData();
                formData.append('file', f);

                try 
                {
                    let response = await httpAPI({
                        url,
                        method: 'POST',
                        data: formData,
                        headers: { 'Content-Type': 'multipart/form-data', 'isCommon':  isCommon},
                        onUploadProgress: (progressEvent) => {
                            let index = getters.getLoadingAttachmnets[currentDocumentId].indexOf(getters.getLoadingAttachmnets[currentDocumentId].find(i => i.Id == comment.Id));
                            let progress = `${Math.trunc((100/progressEvent.total)*progressEvent.loaded)}%`;
                            
                            if (attachment.Progress != progress)
                                commit('UPDATE_lOADING_COMMENT_ATTACHMENT', { property: `${currentDocumentId}[${index}].Attachment.Progress`, value: progress });                            
                        },
                        cancelToken: attachment.CancelTokenSource.token,
                        skipErrorHandler: true
                    });

                    if (response.data.Success && response.data.Payload.Result == "OK")
                    {
                        await commit('global/comments/DEL_LOADIGN_COMMENT_ATTACHMENT', { id: currentDocumentId, comment: comment }, { root: true });
                        
                        if (currentDocumentId == state.currentDocumentId)
                        {
                            let index = state.dataSource.indexOf(comment);
                            await commit('UPDATE_DATASOURCE', { index: index, value: response.data.Payload.Data.Object })
                            await dispatch('global/actionsource/updatePageCounter', { tabId: '0202150', increase: true }, { root: true });
                        }

                        this._vm.$notify.success(i18n.t('Файл_filename_успешно_загружен.message', {filename: attachment.Name}));
                    }
                    else
                    {
                        if (currentDocumentId == state.currentDocumentId)
                        {
                            comment.Attachment.Message = response.data.Success ? response.data.Payload.Message : response.data.Message;
                            delete  comment.Attachment.Progress;

                            let index = state.dataSource.indexOf(comment);
                            await commit('UPDATE_DATASOURCE', { index: index, value: comment })
                            await commit('global/comments/DEL_LOADIGN_COMMENT_ATTACHMENT', { id: currentDocumentId, comment: comment }, { root: true });
                        }

                        this._vm.$notify.alert(i18n.t('Ошибка_загрузки_файла:_filename_with_reason.message', { filename: attachment.Name, reason: response.data.Success ? response.data.Payload.Message : response.data.Message }));
                    }
                }
                catch (exception) 
                {
                    comment.Attachment.Message = Axios.isCancel(exception) ? i18n.t('Загрузка_отменена') : i18n.t('Ошибка_загрузки_файла');
                    delete  comment.Attachment.Progress;                    
                    let index = state.dataSource.indexOf(comment);
                    await commit('UPDATE_DATASOURCE', { index: index, value: comment })
                    await commit('global/comments/DEL_LOADIGN_COMMENT_ATTACHMENT', { id: currentDocumentId, comment: comment }, { root: true });

                    attachment.CancelTokenSource.cancel();
                    this._vm.$notify.alert(i18n.t('Ошибка_загрузки_файла:_filename.message', { filename: attachment.Name }));
                }
            }));

            e.target.value = null;
        },
        async onFileIQalaCommentPicked({ state, commit, getters, dispatch, rootGetters }, { e }) {

            await Promise.all(Array.from(e.target.files).map( async (f) => {
                    
                let currentTimeStamp = await dispatch('documents/references/getTimestamp', null, { root: true });
                let attachment = sys.prepareAttachment(f, state.dataSource, this._vm.$notify);
                let comment = {
                    Id: sys.generateUUID(),
                    AuthorId: rootGetters['global/auth/getUserInfo'].WorkplaceId,                    
                    AuthorName: rootGetters['global/auth/getUserInfo'].UserName,
                    EnterpriseName: rootGetters['global/auth/getUserInfo'].EnterpriseName,
                    CommentDate: sys.dateFormat(currentTimeStamp, 'DD.MM.YYYY HH:mm:ss'),
                    Attachment: attachment,
                    IsNew: true
                };

                let currentDocumentId = rootGetters['global/actionsource/getDataSourceDocumentId']

                await commit('global/comments/ADD_LOADIGN_COMMENT_ATTACHMENT', { id: currentDocumentId, comment: comment }, { root: true })
                await commit('global/comments/PUSH_DATASOURCE', { comment }, { root : true });                

                if (attachment.Message)
                {
                    await commit('global/comments/DEL_LOADIGN_COMMENT_ATTACHMENT', { id: currentDocumentId, comment: comment }, { root: true });
                    return;
                }

                let formData = new FormData();
                formData.append('file', f);

                try 
                {
                    let response = await httpAPI({
                        url: `/api/actions/saveiqalacommentattachment?id=${currentDocumentId}&fileName=${attachment.Name}&fileSize=${attachment.Length}`,
                        method: 'POST',
                        data: formData,
                        headers: { 'Content-Type': 'multipart/form-data', 'isCommon': rootGetters['global/actionsource/isDataSourceCommon'] },
                        onUploadProgress: (progressEvent) => {
                            let index = getters.getLoadingAttachmnets[currentDocumentId].indexOf(getters.getLoadingAttachmnets[currentDocumentId].find(i => i.Id == comment.Id));
                            let progress = `${Math.trunc((100/progressEvent.total)*progressEvent.loaded)}%`;
                            if (attachment.Progress != progress)
                                commit('UPDATE_lOADING_COMMENT_ATTACHMENT', { property: `${currentDocumentId}[${index}].Attachment.Progress`, value: progress });                            
                        },
                        cancelToken: attachment.CancelTokenSource.token,
                        skipErrorHandler: true
                    });

                    if (response.data.Success && response.data.Payload.Result == "OK")
                    {
                        await commit('global/comments/DEL_LOADIGN_COMMENT_ATTACHMENT', { id: currentDocumentId, comment: comment }, { root: true });
                        
                        if (currentDocumentId == state.currentDocumentId)
                        {
                            let index = state.dataSource.indexOf(comment);
                            await commit('UPDATE_DATASOURCE', { index: index, value: response.data.Payload.Data.Object })
                            await dispatch('global/actionsource/updatePageCounter', { tabId: '0202150', increase: true }, { root: true });
                        }

                        this._vm.$notify.success(i18n.t('Файл_filename_успешно_загружен.message', {filename: attachment.Name}));
                    }
                    else
                    {
                        if (currentDocumentId == state.currentDocumentId)
                        {
                            comment.Attachment.Message = response.data.Success ? response.data.Payload.Message : response.data.Message;
                            delete  comment.Attachment.Progress;

                            let index = state.dataSource.indexOf(comment);
                            await commit('UPDATE_DATASOURCE', { index: index, value: comment })
                            await commit('global/comments/DEL_LOADIGN_COMMENT_ATTACHMENT', { id: currentDocumentId, comment: comment }, { root: true });
                            //await commit('documentcomments/SET_DATASOURCE', state.dataSource.map(x => x), { root: true });
                        }

                        this._vm.$notify.alert(i18n.t('Ошибка_загрузки_файла:_filename_with_reason.message', { filename: attachment.Name, reason: response.data.Success ? response.data.Payload.Message : response.data.Message }));
                    }
                }
                catch (exception) 
                {
                    comment.Atachment.Message = Axios.isCancel(exception) ? i18n.t('Загрузка_отменена') : i18n.t('Ошибка_загрузки_файла');
                    delete  comment.Attachment.Progress;                    
                    let index = state.dataSource.indexOf(comment);
                    await commit('UPDATE_DATASOURCE', { index: index, value: comment })
                    await commit('global/comments/DEL_LOADIGN_COMMENT_ATTACHMENT', { id: currentDocumentId, comment: comment }, { root: true });

                    attachment.CancelTokenSource.cancel();
                    //await commit('documentcomments/SET_DATASOURCE', { dataSource: state.dataSource.map(x => x) }, { root: true });
                    this._vm.$notify.alert(i18n.t('Ошибка_загрузки_файла:_filename.message', { filename: attachment.Name }));
                }
            }));

            e.target.value = null;
        },
    },
    getters: {
        getLoadingAttachmnets: s => s.loadingAttachments,
        getIsActive: s => s.isActive,
        getIsPending: s => s.isPendig,
        getDataSource: s => s.dataSource,        
    },
};

export default comments;